import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';

import Icon from 'shared/modules/common/components/atoms/Icon';
import generateID from 'shared/modules/common/utils/generate-id';

type Props = {
  title?: string;
  onBackButtonPress: () => void;
  id?: string;
};

const NavigationBar = (props: Props) => {
  return (
    <View
      style={style.root}
      /** Generate HTML and Test IDs  */
      {...generateID(props.id)}
    >
      <TouchableOpacity
        onPress={props.onBackButtonPress}
        /** Generate HTML and Test IDs  */
        {...generateID(props.id && `${props.id}-back-button`)}
      >
        <Icon name="back" size="32" />
      </TouchableOpacity>
      <Text style={style.title}>{props.title}</Text>
    </View>
  );
};

const style = StyleSheet.create({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 32,
  },
  title: {
    fontWeight: 'bold',
    flexGrow: 1,
    marginRight: 32,
    textAlign: 'center',
  },
});

export default NavigationBar;
